import { useMemo } from "react";

import { IssueType, ProjectIssueFragment } from "@/generated/graphql";

import { nestProjectIssues } from "../utils";
import { useProjectIssuesTable } from "./use-project-issues-table";

export function useProjectManagementBoard(
  projectIssues: ProjectIssueFragment[],
  isShowTasksOnly: boolean
) {
  const issues = useMemo(
    () =>
      isShowTasksOnly
        ? projectIssues.filter(
            (i) => i.type === IssueType.Task && i.parentId === null
          )
        : projectIssues.filter(
            (i) =>
              i.type === IssueType.Milestone ||
              (i.type === IssueType.Task && i.parentId !== null)
          ),
    [isShowTasksOnly, projectIssues]
  );

  const processedData = useMemo(() => nestProjectIssues(issues), [issues]);

  const table = useProjectIssuesTable({
    data: processedData,
    firstRowId: processedData[0] ? processedData[0]?.id : null,
  });

  const totalTasksCount = useMemo(() => {
    return issues.filter((i) => i.type === IssueType.Task).length;
  }, [issues]);

  return {
    table,
    totalTasksCount,
  };
}
